import React from "react";

export default function DemoOverlay(): React.ReactElement {
  return (
    <div
      data-demo-overlay="true"
      aria-hidden="true"
      className="fixed inset-0 z-[9999] pointer-events-none flex items-center justify-center"
    >
      <div className="select-none whitespace-nowrap font-extrabold text-red-600/20 transform -rotate-6 sm:-rotate-8 md:-rotate-12 text-5xl sm:text-6xl md:text-8xl lg:text-9xl">
        DEMO
      </div>
    </div>
  );
}
